import { Button, Stack, SxProps, Theme } from '@mui/material';

import Icon from 'components/@icons/Icon';

import QuantityIndicator from './QuantityIndicator';

interface Props {
  quantity: number;
  isRemoveDisabled?: boolean;
  isAddDisabled?: boolean;
  sx?: SxProps<Theme>;
  onRemove: () => void;
  onAdd: () => void;
}

const AmountSelector = ({
  quantity,
  isRemoveDisabled = false,
  isAddDisabled = false,
  onRemove,
  onAdd,
  sx,
}: Props) => {
  return (
    <Stack direction="row" sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onRemove();
        }}
        disabled={isRemoveDisabled}
        aria-label="Remove"
      >
        <Icon name="Minus" fontSize={18} />
      </Button>
      <QuantityIndicator quantity={quantity} />
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onAdd();
        }}
        disabled={isAddDisabled}
        aria-label="Add"
      >
        <Icon name="Plus" fontSize={18} />
      </Button>
    </Stack>
  );
};

export default AmountSelector;
